import { render } from "./JudgeEvents.vue?vue&type=template&id=3d487b7a&scoped=true"
import script from "./JudgeEvents.vue?vue&type=script&lang=js"
export * from "./JudgeEvents.vue?vue&type=script&lang=js"

import "./JudgeEvents.vue?vue&type=style&index=0&id=3d487b7a&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d487b7a"]])

export default __exports__